import styled from 'styled-components';
import { css, breakpoints } from '../../../../styles/theme';
import { SummaryPriceDetailsStyled } from '../../SummaryPriceDetailsStyled';
import { rem } from 'polished';

export const SummaryPriceDetailsOV = styled(SummaryPriceDetailsStyled)`
    ${({ isBasket }) =>
        !isBasket &&
        css`
            border-top: ${rem(1)} solid #73767a;
            border-bottom: ${rem(1)} solid #73767a;
        `}

    ${({ isBasket, isDealer }) =>
        !isBasket &&
        !isDealer &&
        css`
            border-top: unset;
            border-bottom: unset;
            @media (min-width: ${breakpoints.sm}px) {
                border-top: ${rem(1)} solid #73767a;
                border-bottom: ${rem(1)} solid #73767a;
            }
        `}
    .titleWrapper {
        .title {
            text-transform: capitalize;
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }

    .descriptionTitle {
        text-transform: uppercase;
        font-size: ${rem(16)};
    }

    .descriptionWrapper {
        .info {
            .key {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
                color: ${({ theme }) => theme.colors.grey1};
            }
        }
    }

    .noValidityDate {
        & > div {
            justify-content: space-between;
            width: 100%;
        }
    }

    .totalPriceWrapper {
        .prefix,
        .suffix {
            text-transform: lowercase;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        .totalPrice {
            .cashPrice,
            .monthlyPrice {
                font-size: ${rem(20)};
            }
        }

        .totalPriceTitle {
            font-size: ${rem('16px')};
        }
    }

    .configuration {
        button {
            color: ${({ theme }) => theme.colors.black2};

            &:hover,
            &:focus-visible {
                text-decoration: underline;
            }
        }
    }

    .priceWrapper,
    .totalPriceWrapper,
    .finance {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }
`;
